"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
DownloadFactory.$inject = ['api'];
function DownloadFactory(api) {
    var service = {};
    service.create = function (type, id, data) {
        return api.report('/b2b/documents', type, id, data);
    };
    service.print = function (type, id) {
        return coreBuild(type, id, 'print');
    };
    service.download = function (type, id) {
        return coreBuild(type, id, 'download');
    };
    service.directDownload = function (type, id, data) {
        return coreBuild(type, id, 'download', data);
    };
    function coreBuild(type, id, action, data) {
        if (data === void 0) { data = []; }
        return service.create(type, id, data).then(function (doc) {
            var file = b64toBlob(doc.content, doctype(doc.type));
            var fileURL = window.URL.createObjectURL(file);
            switch (action) {
                case 'print':
                    var printWindow = window.open(fileURL, '_blank');
                    printWindow.onload = function () {
                        var isIE = /(MSIE|Trident\/|Edge\/)/i.test(navigator.userAgent);
                        if (isIE) {
                            printWindow.print();
                            setTimeout(function () { printWindow.close(); }, 100);
                        }
                        else {
                            setTimeout(function () { printWindow.print(); }, 500);
                            printWindow.onfocus = function () { setTimeout(function () { printWindow.close(); }, 500); };
                        }
                    };
                    break;
                case 'download':
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(file, fullname(doc));
                    }
                    else {
                        var anchor = angular.element('<a></a>');
                        anchor.css({ display: 'none' }); // Make sure it's not visible
                        angular.element(document.body).append(anchor); // Attach to document
                        anchor.attr({
                            href: fileURL,
                            download: fullname(doc)
                        })[0].click();
                        anchor.remove(); // Clean it up afterwards
                    }
                    break;
            }
        });
    }
    function doctype(type) {
        switch (type) {
            case 'pdf':
            default:
                return 'application/pdf';
        }
    }
    function fullname(doc) {
        return doc.name + '.' + doc.type;
    }
    function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    return service;
}
exports.default = angular.module('rinca.core.download', [])
    .factory('_download', DownloadFactory);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/services/download.js
// module id = 294
// module chunks = 0